<ng-container *ngIf="{currentLocale: currentLocale$ | async} as data">
  <ng-content *ngIf="toggle; else defaultView"></ng-content>

  <ng-template #defaultView>
    <button class="link link--underline-in h4" (click)="onOpen()">{{ buttonText }}</button>
  </ng-template>

  <div class="modal _mobile-full l-wrapper" *ngIf="isShowModal">
    <div  class="modal__overlay" (click)="onClose()"></div>
    <div class="modal__container">
      <div class="modal__content">
        <div class="modal__head l-wrapper">
          <div class="modal__title h1" i18n="@@SelectLanguage">Select language</div>
          <div class="modal__close">
            <button type="button" class="button-icon button-icon--th-ctrl" (click)="onClose()">
              <i class="icomoon icomoon--close"></i>
            </button>
          </div>
        </div>

        <div class="modal__body l-wrapper">
          <div class="picker-list">
            <div class="picker-list__item" *ngFor="let langKey of langKeys">
              <button class="picker-item" (click)="onSelectLang(langKey, data.currentLocale)">
                <div class="picker-item__label h4">{{ langOptions[langKey].translateName }}</div>
                <div class="picker-item__right" *ngIf="data.currentLocale && data.currentLocale === langKey">
                  <i class="icomoon icomoon--check"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
